// /** @module maps/base */
import {getUrl} from "../main_ptx";

const Base = require('../../../web-dep/node_modules/basejs');

/**
 * @alias Ptx.maps.BaseMap
 */
export const BaseMap = Base.extend({
	/** @lends module:maps/base */
	name: "Ptx base map",
	map: null, //raw object of map
	$element: null, //DOM element with map
	ready: false, //is map ready?
	clusters: {}, //cluster marker, keys are cluster types
	geoJson: null, //geojson data
	geoBounds: null, //bounds for geojson data, if determined
	opts: null, //options for map
	autofocus: true, // hold object in map center
	autozoom: true, //automatically zoom to bounds
	showLabels: true, //show unit names?
	showClusters: true, //show unit names?
	/**
	 * @deprecated replaced by {@link showGeozone}
	 */
	showPoi: true, //show poi?
	/**
	 * @deprecated replaced by {@link showGeozoneLabels}
	 */
	showPoiLabels: true, //show poi?
	showGeozone: true,
	showGeozoneLabels: true,
	// show unit names?
	showTraffic: false,
	// Units that can be rendered on map (in table on map/map.htm page)
	visibleUnits: null,
	visibleTrace: null,
	logbookMapDefaultZoom: 10,//default zoom for logbook maps
	/**
	 * @deprecated replaced by {@link geos}
	 */
	poi: [], //object for poi
	geozone: [],//object for geozones
	geos: [],
	bts: [], //object for bts
	poiMenu: null, //holder for create new POI menu/window
	trafficLayer: null,
	draggablePoints: false,
	geoMarkers: [],
	geoFeatures: null,
	geoMarkersDraggable: false,

	drawnItems: null, //all items drawn on map
	editTool: null, //currently used edit tool
	editToolName: 'POLYGON', //currently used edit tool name, by default polygon
	editToolList: {}, //available edittools
	mapSettings: {}, //map settings coming from server, eg. overlays


	/**
	 * Create map object, if parameters specified, calls @link create function and make map
	 * @param mapContainer @see create()
	 * @param opts @see create()
	 * @param mapSettings
	 */
	constructor: function (mapContainer, opts, mapSettings) {
		if (mapContainer) {
			this.create(mapContainer, opts, mapSettings)
		}
	},

	/**
	 * Load given API if necessary and allow post-init of created map by callback when ready
	 * Subclasses must override this method, and call this base implementation when overriding!!
	 * @param mapContainer id of element where to create the map
	 * @param opts various options for map, initCallback(map) - what to do after map load, mapType - Ptx.maps.TYPE_ constant
	 * @param mapSettings
	 */
	create: function (mapContainer, opts, mapSettings) {
		this.$element = $('#' + mapContainer);
		this.opts = opts;
		this.mapSettings = mapSettings;
		this.visibleUnits = [];
	},

	/**
	 * Destroy current map and remove DOM element of it
	 * and do all cleanup
	 * Subclasses must override this method, and call this base implementation when overriding!!
	 */
	destroy: function () {
		this.$element.remove(); //remove from DOM
		this.$element = null;
		this.markerCluster = null;
	},
	/**
	 * Resize (refresh) the map by parent element.
	 * Use it after change size of parent element.
	 */
	resize: function () {
	},

	/**
	 * Log message to console
	 */
	log: function (msg) {
		console.log("[" + this.name + "]" + msg);
	},

	/**
	 * Return object of map as created by subclasses
	 */
	getRawMap: function () {
		return this.map;
	},

	/**
	 * @param lat,lon,zoom
	 */
	centerAndZoom: function (lat, lon, zoom) {
	},
	/**
	 * Fit bounds in string form : 49.198756 13.471985,50.426894 17.427063
	 * Left top, bottom right corner
	 */
	fitStrBounds: function (bounds) {
	},
	/**
	 * Zoom to given level
	 */
	zoom: function (zoom) {
	},

	/**
	 * set zoom and do it
	 */
	setZoom: function () {
	},

	/**
	 * get zoom of the map
	 */
	getZoom: function () {
	},

	/**
	 * event when the zoom or position map changed
	 */
	positionChanged: function () {
	},

	/**
	 * It center and zoom to first object in geo json
	 */
	centerAndZoomToFirstGeoJson: function () {
		var self = this;
		self.centerAndZoom(self.geoJson.features[0].geometry.coordinates[1], self.geoJson.features[0].geometry.coordinates[0], self.maxDefaultZoom);
		self.forceRefreshMap();
	},
	isGeoJSONValid: function (data) {
		var type = data.type;
		var coords = data.coordinates.length;

		if (type == 'Point') {
			return coords == 1;
		} else if (type == 'LineString') {
			return coords >= 2;
		} else if (type == 'Polygon') {
			return coords >= 4;
		}
		return false;
	},

	/**
	 * set lat lon and do it
	 */
	setLatLng: function () {
	},

	/**
	 * get lat lon of the map
	 */
	getLatLng: function () {
	},

	/**
	 * show tp clusters after some zoom is reached
	 */
	showTpAfterZoom: function () {
	},

	/**
	 * Returns function that is responsible for initial setup of map
	 * @return function to be called
	 */
	findMapCreatorFunction_: function () {
		var self = this;
		var mt = self.opts.mapType;

		if (mt === MAP_TYPE_MAIN) {
			return self.prepareMainMap();
		} else if (mt === MAP_TYPE_LOGBOOK) {
			return self.prepareLogbookMap();
		} else if (mt === MAP_TYPE_SIMPLE) {
			return self.prepareSimpleMap();
		} else if (mt === MAP_TYPE_TRACE) {
			return self.prepareTraceMap();
		} else if (mt === MAP_TYPE_EOD) {
			self.showTpDefaultZoom = 1;
			return self.prepareLogbookMap();
		} else if (mt === MAP_TYPE_TRACE_ANALYZE) {
			return self.prepareTraceAnalyzeMap();
		}
	},


	/**
	 * Create and settings animation marker and prepare for start
	 * @return void
	 */
	createAnimatedMarker: function (vehicle) {
		var self = this;
		var data = self.getAnimatedPolyline();

		self.AM.init(self.map, {data: data});

		// set the Bulgarian constants
		self.AM.tempo = Math.round(Math.sqrt(data.length) * 100);
		self.AM.smooth = Math.round(1 / data.length * self.AM.tempo);

		self.AM.specialSpeed = function () {
			var speed = Math.max(1, Math.round(self.getZoom() * self.getZoom() * self.getZoom() / 729));
			if (self.getZoom() < 10) {
				speed = Math.max(speed, 2);
			} else if (self.getZoom() >= 18) {
				speed *= 2;
			}
			self.AM.smooth = Math.round(1 / data.length * self.AM.tempo * speed);
			return speed;
		};

		self.creators.createAnimatedVehicle(self, vehicle, data[0]);
		self.AM.setMarker(self.animatedMarker);

		self.AM.moveCallback = function (d, i) {
			var vehicleIconClass = "<i class='map-icon icon-" + vehicle.ico + "'></i>";
			var vehicleContent = "";

			self.AM.sleep = null;

			if (typeof data[i + 1] !== 'undefined') {
				var duration = moment(moment(data[i + 1].properties.unixTime, "x").diff(d.properties.unixTime, "x"));

				if (data[i + 1].properties.state == "START" && typeof data[i + 2] !== 'undefined') {
					var timeStart = data[i + 1].properties.unixTime;
					var timeEnd = data[i + 2].properties.unixTime;

					var durationStop = duration.subtract(1, 'hour').format('H:mm');
					vehicleContent = "<div class='vehicle-timeline-content'>"+vehicleIconClass+"<strong>Stop: "+durationStop+"min</strong></div>";
					$('.vehicle-timeline').html(vehicleContent);

					self.AM.sleep = 1500;
				} else {
					var timeHum = moment(d.properties.unixTime, "x").tz(vehicle.tz).format("H:mm");
					vehicleContent = "<div class='vehicle-timeline-content'>"+vehicleIconClass+"<strong>"+timeHum+"</strong></div>";
					$('.vehicle-timeline').html(vehicleContent);
				}
				if (duration > 200000) {
					duration = 200000
				}

				if (typeof data[i + 2] === 'undefined') {
					var timeHum = moment(data[i + 1].properties.unixTime, "x").tz(vehicle.tz).format("H:mm");
					vehicleContent = "<div class='vehicle-timeline-content'>"+vehicleIconClass+"<strong>"+timeHum+"</strong></div>";
					$('.vehicle-timeline').html(vehicleContent);
				}

				self.AM.speed = duration;
			}
		};
		self.AM.endCallback = function () {
			self.stopAnimatedMarker();
		}
	},


	/**
	 * play animated marker if exist
	 * @return void
	 */
	playAnimatedMarker: function () {
	},


	/**
	 * Pause animated marker if exist
	 * @return void
	 */
	pauseAnimatedMarker: function () {
		var self = this;
		if (self.AM) {
			self.AM.pause();
		}
	},


	/**
	 * Stop animated marker if exist
	 * @return void
	 */
	stopAnimatedMarker: function () {
		var self = this;

		if (self.AM) {
			self.AM.stop();
			$('#play').prop('disabled', false);
			$('#pause').attr('disabled', 'disabled');
			$('#stop').attr('disabled', 'disabled');
		}
	},

	/**
	 * get data from geoJson and prepare for animated marker (all points)
	 * @return void
	 */
	getAnimatedPolyline: function () {
		var self = this;
		var polylineData = [];

		self.geoJson.features.forEach(function (data) {
			// need only continuous TP
			if (data.properties.state == "CONTINUE" || data.properties.state == "START") {
				polylineData.push({
					'lat': data.geometry.coordinates[1],
					'lon': data.geometry.coordinates[0],
					'properties': data.properties
				});
			}
		})
		return polylineData;
	},

	prepareMainMap: function () {
	},
	prepareLogbookMap: function () {
	},
	prepareSimpleMap: function () {
	},
	prepareTraceMap: function () {
	},
	prepareTraceAnalyzeMap: function () {
	},

	/**
	 * Show GeoJSON objects on map, with proper styling
	 * @param geoJsonData - data
	 * @param afterLoadCallback what to do after data is loaded, if null or undefined center and zoom to bounds of data
	 */
	gjDataShow: function (geoJsonData, afterLoadCallback) {
		if(geoJsonData)
			this.geoJson = geoJsonData;
	},

	/**
	 * Center map to loaded data and zoom to show all
	 * @param zoom - optional zoom to reset default zoom determined by bounds
	 */
	gjDataShowBounds: function (zoom) {
	},

	/**
	 * Center map to loaded data and zoom to show all
	 * @param options - optional {zoom}
	 */
	gjDataFitBounds: function (options) {
	},

	/**
	 * Hide GeoJSON objects from map
	 * * @param clearPoiAndGeoz - optional boolean (delete Poi from map?)
	 */
	gjDataHide: function (clearPoiAndGeoz) {
		if (typeof clearPoiAndGeoz !== "undefined" && clearPoiAndGeoz === true) {
			this.poi = [];
			this.geozone = [];
			this.geos = [];
		}
	},


	/**
	 * Switch between fix map and not fix map
	 * @param boolean show
	 */
	markerShowAutofocus: function (autofocus) {
		this.autofocus = autofocus;
		this.gjDataShowBounds();
	},

	/**
	 * Switch between fix map and not fix map
	 * @param boolean show
	 */
	markerShowAutozoom: function (autozoom) {
		this.autozoom = autozoom;
		this.gjDataShowBounds();
	},

	/**
	 * Show or hide marker titles on map, must be called by ancestors
	 * @param type marker property "ptxType" to show or hide, can be "ALL" to hide all
	 * @param boolean show
	 */
	markerShowLabels: function (type, show) {
		if (typeof show === 'boolean') {
			this.showLabels = show;
		}
	},
	/**
	 * Toggle marker titles on map
	 * @param type marker propery "ptxType" to show or hide, can be "ALL" to hide all
	 */
	markerToggleLabels: function (type) {
		this.markerShowLabels(type, !this.showLabels);
	},

	/**
	 * Create or destroy clusters of given type
	 * @param showClusters - boolean to cluster or not to cluster
	 */
	markerToggleClusters: function (showClusters) {
		if (typeof showClusters === 'boolean') {
			this.showClusters = showClusters;
		}
	},

	/**
	 * Create or destroy poi of given type
	 * @param showPoi - boolean show POI
	 */
	togglePoi: function (showPoi) {
		if (typeof showPoi === 'boolean') {
			this.showPoi = showPoi;
		}
	},

	toggleGeozone: function (showGeozone) {
		if (typeof showGeozone === 'boolean') {
			this.showGeozone = showGeozone;
		}
	},

	toggleGeozoneLabels: function (showGeozoneLabels) {
		const self = this;

		if (typeof showGeozoneLabels === 'boolean') {
			self.showGeozoneLabels = showGeozoneLabels;
			if (self.showGeozoneLabels == true) {
				$('.label-geozone').removeClass('hidden')
			} else {
				$('.label-geozone').addClass('hidden')
			}
		}
	},

	/**
	 * Create or destroy poi labels of given type
	 * @param showPoi - boolean show POI
	 */
	togglePoiLabels: function (showPoiLabels) {
		var self = this
		if (typeof showPoiLabels === 'boolean') {
			this.showPoiLabels = showPoiLabels;
			if (self.showPoiLabels == true) {
				$('.label-poi').removeClass('hidden')
			} else {
				$('.label-poi').addClass('hidden')
			}
		}
	},

	/**
	 * Create or destroy traffic of given type
	 * @param traffic - boolean to show traffic or not
	 */
	toogleTraffic: function (traffic) {
		if (typeof traffic === 'boolean') {
			this.showTraffic = traffic;
		}
	},

	/**
	 * Create vehicle SVG marker
	 */
	getVehicleMarker: function (obj) {
		var self = this;
		var flicker = '';
		if (obj.speed > 0) {
			flicker = 'anim-flicker'
		}
		var color = "#333333";
		if (typeof obj.color !== 'undefined') {
			if (obj.color.length == 7) {
				color = obj.color;
			} else {
				color = "#" + obj.color;
			}
		}
		var c = '<div class="map-vehicle-circle box-shadow"></div>';
		c += '<div><div class="map-vehicle-circle-in" style="background-color: #' + obj.color + '"></div></div>';

		c += '<div class="arrow_box vehicle-marker box-shadow vehicle-marker-type-' + obj.type + '">';
		c += '<div class="vehicle-label-panel">';
		c += '<div class="map-vehicle-color" style="border-left: 7px solid ' + color + ';"></div>';
		c += '<i class="map-icon icon-' + obj.ico + ' ' + flicker + ' text-' + obj.state + ' font-26"></i>';
		if (typeof obj.name !== 'undefined') {
			c += '<strong class="title map-vehicle-title"><div>' + obj.name + '&nbsp;</div>';
			if (obj.displayDriverName && obj.driver)
				c += '<div style="padding-top: 3px; font-weight: normal;">' + obj.driver + '&nbsp;</div>';
			c += '</strong>';
		}

		c += "</div>";
		c += '</div>';

		return '<div>' + c + '</div>';
	},
	/**
	 * @param type - tp or eod
	 * @param color - color :)
	 * @param orientation - angle of icon
	 */
	getTpIconUrl: function (type, color, isRT41) {
		if (type == 'tp_tp') {
			return getUrl('/img/u/map/direction/direction_' + color + '_0.png');
		} else if (type == 'tp_eod') {
			if (isRT41) {
				return getUrl('/img/u/map/direction/dir_RT_41.png');
			} else {
				return getUrl('/img/u/ico/noncommunicating-unit_alarm.gif');
			}
		}
	},

	/**
	 * @param bool isRT41
	 * @param string icon (urlOfImage)
	 * @param int orientation (in deg)
	 * return html element with rotated icon
	 */
	createTPContent: function (isRT41, icon, orientation) {
		var content;
		if (isRT41) {
			content = '<div class="RT41" style="width: 32px">';
			content += '<img width="16" height="16" src="' + icon + '" class="RT41-icon" style="transform: rotate(' + orientation + 'deg)">';
			content += '<img width="16" height="16" src="' + getUrl('/img/u/map/direction/exclamation_mark.png') + '">';
			content += '</div>';
		} else {
			content = '<img width="16" height="16" src="' + icon + '" class="tp-icon" style="transform: rotate(' + orientation + 'deg)">';
		}
		return content;
	},

	/**
	 * Create vehicle info from object
	 * @param obj -car properties : name, speed, time, address, lat, lon, regPlate
	 */
	getVehicleInfoBox: function (obj) {
		var s = '<div id="' + obj.domId + '" class="marker-info clearfix" style="min-width:150px;">';
		if (typeof obj.name !== 'undefined') {
			s += '<strong>' + obj.name;
			if (typeof obj.regPlate !== 'undefined')
				s += '<small>' + obj.regPlate + '</small>';
			s += '</strong><br />';
		}
		if (typeof obj.time !== 'undefined') {
			s += '' + obj.time + '<br />';
		}
		var addr = "";
		if (typeof obj.address !== 'undefined') {
			addr = obj.address;
		} else {
			if (Ptx.page.ctx.linkToPosition != true) {
				addr = this.getResolveAddressBox(obj.address, obj.lat, obj.lon, 1)
			}
		}
		s += '' + addr + '<br />';
		if (typeof obj.lat !== 'undefined') {
			s += '<strong>GPS:</strong> ' + Ptx.fn.formatGps(obj) + '<br />';
		}
		if (obj.driver) {
			s += '<strong>' + Ptx.getMsg('common.driver') + ':</strong> ' + obj.driver + '<br />';
		}
		if (obj.speed) {
			s += '<strong>' + Ptx.getMsg('common.speed') + ':</strong> ' + obj.speed + ' km/h<br />';
		}
		if (obj.trackNote) {
			s += '<strong>' + Ptx.getMsg('common.note') + ':</strong> ' + obj.trackNote + '<br />';
		}

		if (Ptx.page.ctx.linkToPosition != true && obj.hideButtonPanel != true) {
			s += '<div class="btn-group text-center" style="margin-top:5px;" role="group">';
			if (obj.authorities['ROLE_USER_SUMMARY']) {
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('common.btn.information') + '" class="btn btn-menu' +
                    ' ptx-show-modal" href="' + getUrl('/vehicle/card/list.htm?tab=1&unitId=' + obj.unitId) + '">'+Ptx.html.icon({icon: "fa-info", cssClass: "fa-fw"})+'</a>';
			}
			if (obj.authorities['ROLE_USER_LOGBOOK']) {
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('menu.logbook') + '" class="btn btn-edit" href="' + getUrl('/history/logbook.htm?filterUnitId=' + obj.unitId) + '">'+Ptx.html.icon({icon: "fa-book", cssClass: "fa-fw"})+'</a>';
			}
			if (obj.authorities['ROLE_USER_LINK_TO_POSITION']) {
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('common.btn.share') + '" class="btn btn-edit ptx-show-modal"' +
                    ' href="' + getUrl('/settings/linksToPosition/insert.htm?unitId=' + obj.unitId) + '">'+Ptx.html.icon({icon: "fa-share-alt", cssClass: "fa-fw"})+'</a>';
			}
			if (obj.authorities['ROLE_USER_GEOZONES']) {
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('menu.unit.geozone')
				   + '" class="btn btn-edit ptx-show-modal" href="' + getUrl('/settings/geozones/geozones/insert.htm?unitId=' + obj.unitId)
				   + '" data-ptx-modal-size="modal-full">'+Ptx.html.icon({icon: "fa-circle", cssClass: "fa-fw"})+'</a>';
			}
			if (obj.authorities['ROLE_USER_UNIT_CONFIGURATION']) {
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('unit.settings') + '" class="btn btn-edit ptx-show-modal"' +
                    ' href="' + getUrl('/settings/unitConfiguration/update.htm?id=' + obj.unitId) + '"><i class="fa-solid fa-pencil-alt fa-fw"></i></a>';
			}
				s += '<a data-bs-toggle="tooltip" data-placement="bottom" title="' + Ptx.getMsg('common.btn.hide') + '" class="btn btn-danger hideUnitById"' +
                    ' onclick="Ptx.page.ctx.map.hideUnitById(' + obj.unitId + ')" data-id="' + obj.unitId + '">'+Ptx.html.icon({icon: "fa-times", cssClass: "fa-fw"})+'</a>';
			s += '</div>';
		}
		s += '</div>';


		return s;

	},

	/**
	 * Create track break info from object
	 * @param obj -car properties : name, speed, time, address, lat, lon, regPlate
	 */
	getTrackBreakInfoBox: function (obj) {
		var s = '<div id="' + obj.domId + '" class="marker-info">';
		if (typeof obj.name !== 'undefined') {
			s += '<strong>' + obj.name;
			if (typeof obj.regPlate !== 'undefined')
				s += '<small>' + obj.regPlate + '</small>';
			s += '</strong><br />';
		}
		if (typeof obj.time !== "undefined") {
			s += '' + moment(obj.time).format('L') + ' ' + moment(obj.time).format('LTS') + '<br />';
		}
		var addr;
		if (typeof obj.address !== "undefined") {
			addr = obj.address;
		} else {
			addr = this.getResolveAddressBox(obj.address, obj.lat, obj.lon, 1)
		}
		s += '' + addr + '<br />';
		if (typeof obj.lat !== "undefined") {
			s += '<strong>GPS:</strong> ' + Ptx.fn.formatGps(obj) + '<br />';
		}

		s += '</div>';

		return s;
	},
	/**
	 * hide visible unit by id
	 * @param id
	 */
	hideUnitById: function (id) {
		$('#unit-visible_' + id).click();
	},

	/**
	 * Create trackpoint info from object
	 * @param obj  properties : time, speed, address, lat, lon, tpId, header1, header2, driver
	 */
	getTpInfoBox: function (obj) {
		var addr = "";
		if ( Ptx.page.ctx.linkToPosition != true ) {
			addr = this.getResolveAddressBox(obj.address, obj.lat, obj.lon, obj.tpId);
		}
		var s = '<div id="' + obj.domId + '" class="marker-info">';
		if (obj.header1)
			s += '<strong>' + obj.header1 + '</strong><br />';
		if (obj.header2)
			s += '<strong>' + obj.header2 + '</strong><br />';
		if (obj.speed)
			s += '<strong>' + Ptx.getMsg('common.speed') + ':</strong> ' + obj.speed + ' km/h<br />';
		if (obj.time)
			s += '<strong>' + Ptx.getMsg('common.time') + ':</strong> ' + obj.time + '<br />';
		if (typeof obj.lat !== 'undefined') {
			s += '<strong>GPS:</strong> ' + Ptx.fn.formatGps(obj) + '<br />';
		}
		if (addr)
			s += '<strong>' + Ptx.getMsg('common.address') + ':</strong> ' + addr + '<br />';
		if (obj.driver)
			s += '<strong>' + Ptx.getMsg('common.driver') + ':</strong> ' + obj.driver + '<br/>';
		if (obj.entry)
			s += '<strong>' + Ptx.getMsg('tracePlan.poi.actualArrivalTime') + ':</strong> ' + obj.entry + '<br/>';
		if (obj.resolve)
			s += '<strong>' + Ptx.getMsg('menu.tracePlan.solution') + ':</strong> ' + obj.resolve + '<br/>';
		if (obj.resolveAction)
			s += '<strong>' + Ptx.getMsg('common.descriptionOfSolution') + ':</strong> ' + obj.resolveAction + '<br/>';
		s += '</div>';
		return s;
	},
	/**
	 * Helper for creating address box, that can be online resolved
	 */
	getResolveAddressBox: function (addr, lat, lon, tpId) {
		return Ptx.html.resolvAddressBox('span', 'trackPoint', addr, tpId, lat, lon, '', '', '');
	},

	/**
	 * Go through unit table on page, and gets checked units to be shown on map
	 * @return {[]}
	 */
	getVisibleUnits: function () {
		var t = $(unitTableSelector).dataTable();
		var rows = t._('tr', {"filter": "applied"});
		var visible = [], notVisible = [];

		for (var i = 0; i < rows.length; i++) {
			var unitId = (rows[i]).id;
			var checked = $('#unit-visible_' + unitId).is(':checked');

			if (checked) {
				visible.push(unitId);
			} else {
				notVisible.push(unitId);
			}
		}
		Ptx.tables.map.visibleUnits = this.visibleUnits = visible;
		Ptx.tables.map.notVisibleUnits = notVisible;

		// set units array ("mapVisibleUnits") only when no specific unit selected to show
		if ( Ptx.tables.map.unitId == null ) {
			Ptx.fn.setSession("mapVisibleUnits", {
				visibleUnits: visible,
				notVisibleUnits: notVisible
			});
		}

		return visible;
	},

	/**
	 * Clears map and show units on map again.
	 * @param geoData - optional geoJSON data, if empty then use previously loaded data, can be false
	 * @param firstLoad - optional boolean (delete Poi from map? called inside clearClusters() method)
	 * @param afterCallback see {@link maps/base#gjDataShow}
	 * @param showVisibleUnitsOnly if set to false then filtering to show only visible units by table (by data in variable {@link visibleUnits})
	 * 							 is NOT performed. Default value of this argument is true if is undefined.
	 */
	showUnitsOnMap: function (geoData, firstLoad, afterCallback, showVisibleUnitsOnly) {
		var self = this;
		self.getVisibleUnits();
		self.gjDataHide(firstLoad);

		if (showVisibleUnitsOnly === undefined) {
			showVisibleUnitsOnly = true;
		}

		if (geoData) {
			self.geoJson = geoData;
		}
		if ( showVisibleUnitsOnly && self.geoJson && self.geoJson.features ) {
			//bcs POIs are cached and we dont want to display then duplicated
			if(geoData === false && !firstLoad){
				//Removes poi from features
				self.geoJson.features = self.geoJson.features.filter(function (feat) {
					return !(feat.geometry.type == "Point" && feat.properties.type == "POI")
				});
			}
			//Delete all LineString features which aren't for visible unit   (is LineString && DONT belong to visibleUnits)
			self.geoJson.features.forEach(function (feat) {
				var isGeomTypeLineString = feat.geometry.type === "LineString"; //TODO better would be to use feature type instead of geometry type
				var keep = true;

				if (isGeomTypeLineString) {
					var unitId = feat.properties['unitId'];
					keep =  ( $.inArray( unitId, self.visibleUnits ) > -1 );
				} 
				feat.removeFromLayer = !keep;
				
			});
		}

		self.gjDataShow(self.geoJson, afterCallback);
		self.forceRefreshMap();
	},

	/**
	 * Force refresh map after geoJSON is loaded for main map
	 */
	forceRefreshMap: function () {
	},

	showTooltipOnCursor: function (e, title) {
		e = e || window.event;
		var cursor = {x: 0, y: 0};
		cursor.x = e.originalEvent.clientX;
		cursor.y = e.originalEvent.clientY;

		var html = '<div class="cursor-title bg-primary abs" style="left: ' + cursor.x + 'px; top: ' + cursor.y + 'px">' + title + '</div>';
		$('body').append(html);
	},

	hideTooltipOnCursor: function () {
		$('.cursor-title').hide();
	},
	/**
	 * Return GeoJSON feature style based on its type
	 * @param type - LineString or something else
	 */
	getStyleForFeature: function (type) {
		var self = this;
		if (type == null || typeof (self.geoJsonStyleOpts[type]) === 'undefined') {
			//Bcs we need copy of that object not reference (We dont want to change default values)
			return $.extend({}, self.geoJsonStyleOpts['DEFAULT']);
		} else {
			return $.extend({}, self.geoJsonStyleOpts[type]);
		}
	},

	/**
	 * Get contrast color for labels, so the text is always readable based on the Geozone color
	 * @param hexColor - background color of the label
	 */
	getContrastColor: function (hexColor) {
		hexColor = hexColor.replace('#', '');

		let r = parseInt(hexColor.substring(0, 2), 16);
		let g = parseInt(hexColor.substring(2, 4), 16);
		let b = parseInt(hexColor.substring(4, 6), 16);

		r /= 255; g /= 255; b /= 255;

		const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b; // Relative luminance

		return luminance > 0.5 ? '#111' : '#eee';
	},

	/**
	 * Parse array of points (object with lat, lon properties)
	 * from string like  49.198756 13.471985,50.426894 17.427063
	 * return [{lat:49.198756, lon:13.471985},{lat:50.426894, lon:17.427063}]
	 **/
	parsePoints: function (latLngBounds) {
		if (Array.isArray(latLngBounds) && latLngBounds.length == 4) {
			return [{lat: latLngBounds[0], lon: latLngBounds[2]}, {lat: latLngBounds[1], lon: latLngBounds[3]}];
		}

		function parsePositionFromText(text) {
			var part = text.split(' ');
			var lat = parseFloat(part[0]);
			var lon = parseFloat(part[1]);
			return {lat: lat, lon: lon};
		}

		var pointsStringArray = latLngBounds.split(/ *, */);
		var points = [];
		for (var i = 0; i < pointsStringArray.length; i++) {
			var pointStr = pointsStringArray[i];
			var pointPosition = parsePositionFromText(pointStr);
			points.push(pointPosition);
		}
		return points;
	},
	/**
	 * Helper for inversing coordinates in GeoJSON coords array
	 */
	inverseGeoJSONCoords: function (coordArray) {
		if (coordArray) {
			var res = [];
			for (var i = 0; i < coordArray.length; i++) {
				var pair = coordArray[i];
				var invPair = [];
				invPair.push(pair[1]);
				invPair.push(pair[0]);
				res.push(invPair);
			}
			return res;
		}
		return [];
	},
	/**
	 * Create info box for creating new Geozone from main map
	 */
	createInsertGeozoneBox: function (lat, lon, cId) {
		var html = '<div id="poiMenu-' + this.getJQueryIdSafeCoords(lat, lon) + '">';
		var url = getUrl('/settings/geozones/geozones/create.htm?latitude=' + lat + '&longitude=' + lon + '&cId='+cId);
		html += '<p><strong>GPS:</strong>' +  Ptx.fn.formatGps({ lat:lat, lon:lon })+ '</p>';
		if(this.geoJson && this.geoJson.properties.canAddPoi)
			html += '<a href="' + url + '" class="ptx-show-modal">' + Ptx.getMsg('settings.geozone.popUp.create') + '</a>';

		html += '</div>';
		return html;
	},
	/**
	 * Create safe element id from coordinates
	 * eg. removes commas and dots
	 */
	getJQueryIdSafeCoords: function (lat, lon) {
		return (lat.toFixed(5) + lon.toFixed(5)).toString(16).replace(/\./g, '');
	},

	/**
	 * create new point on map
	 */
	createPoint: function (element) {
	}

});

// //GeoJSON map types
export const MAP_TYPE_MAIN = 'TYPE_MAIN';
export const MAP_TYPE_LOGBOOK = 'TYPE_LOGBOOK';
export const MAP_TYPE_EDIT_POI = 'TYPE_EDIT_POI';
export const MAP_TYPE_EDIT_GZ = 'TYPE_EDIT_GZ';
export const MAP_TYPE_SIMPLE = 'TYPE_SIMPLE';
/** Map type for CREATE the trip/trace plan */
export const MAP_TYPE_TRACE = 'TYPE_TRACE';
/** Map type for SHOW the analysis of trip/trace plan */
export const MAP_TYPE_TRACE_ANALYZE = 'TYPE_TRACE_ANALYZE';
export const MAP_TYPE_EOD = 'TYPE_EOD';
//datatables on map with unit
export const unitTableSelector = '.unit-map-group-table';